/**
 * 汎用的なカート追加機能
 * data-add-to-cart属性を持つ要素に自動的にカート追加機能を付与
 */

(function () {
  "use strict";

  // カート通知を表示
  function showCartNotification(product) {
    const notification = document.getElementById("puremer-cart-notification");
    if (!notification) {
      return;
    }

    // 商品情報を更新
    const productImage = notification.querySelector(
      ".puremer-cart-notification-product__image"
    );
    const productName = notification.querySelector(
      ".puremer-cart-notification-product__name"
    );
    const productPrice = notification.querySelector(
      ".puremer-cart-notification-product__price"
    );

    if (productImage && product.image) {
      productImage.src = product.image;
      productImage.alt = product.title || "";
    }
    if (productName) {
      productName.textContent = product.title || "";
    }
    if (productPrice) {
      productPrice.textContent = product.price || "";
    }

    // 通知を表示
    notification.removeAttribute("hidden");
    notification.removeAttribute("inert");
    notification.classList.add("active");

    // 3秒後に自動的に閉じる
    setTimeout(() => {
      hideCartNotification();
    }, 3000);
  }

  // カート通知を非表示
  function hideCartNotification() {
    const notification = document.getElementById("puremer-cart-notification");
    if (!notification) return;

    notification.classList.remove("active");
    setTimeout(() => {
      notification.setAttribute("hidden", "");
      notification.setAttribute("inert", "");
    }, 300); // アニメーション時間と合わせる
  }

  // カートアイコンのバッジを更新
  function updateCartBadge(count) {
    const badges = document.querySelectorAll("[data-cart-count]");
    badges.forEach((badge) => {
      badge.textContent = count;
      if (count > 0) {
        badge.classList.add("visible");
      } else {
        badge.classList.remove("visible");
      }
    });
  }

  // カート情報を取得して更新
  function fetchAndUpdateCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        updateCartBadge(cart.item_count);
      })
      .catch((error) => {
      });
  }

  // テキストノードのみを更新する関数
  function updateTextNode(element, newText) {
    if (!element) return null;
    
    // 元のテキストを保存
    let originalText = "";
    
    // テキストノードを探す
    for (let node of element.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        originalText = node.textContent;
        node.textContent = newText;
        return originalText;
      }
    }
    
    // テキストノードが見つからない場合、何もしない
    // （data-add-to-cart要素はテキストを持たないため）
    return "";
  }

  // カートに商品を追加
  function addToCart(variantId, productData, buttonElement) {
    // ローディング状態の表示
    const button = buttonElement;
    button.classList.add("loading");

    // ボタンのテキストを保存して変更
    let originalText = "";
    let textElement = null;
    
    // .product-card-button-text要素があるか確認（main-product.liquidの場合）
    textElement = button.querySelector(".product-card-button-text");
    
    if (textElement) {
      // product-card-button-textがある場合のみテキストを更新
      originalText = updateTextNode(textElement, "追加中...");
    }
    // data-add-to-cart要素（products-list.liquid）の場合は、テキストを変更しない

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("カートへの追加に失敗しました");
        }
        return response.json();
      })
      .then((item) => {
        // カート通知を表示
        showCartNotification({
          title: productData.title || item.product_title,
          price: productData.price || formatYenPrice(item.price),
          image: productData.image || item.image,
        });

        // カートバッジを更新
        fetchAndUpdateCart();

        // ボタンの状態を戻す
        button.classList.remove("loading");

        // ボタンのテキストを復元（textElementがある場合のみ）
        if (textElement && originalText) {
          updateTextNode(textElement, originalText);
        }

        // 成功フィードバックを無効化
        // button.classList.add("success");
        // setTimeout(() => {
        //   button.classList.remove("success");
        // }, 1500);
      })
      .catch((error) => {
        alert("カートへの追加に失敗しました。もう一度お試しください。");

        // ボタンの状態を戻す
        button.classList.remove("loading");

        // ボタンのテキストを復元（textElementがある場合のみ）
        if (textElement && originalText) {
          updateTextNode(textElement, originalText);
        }
      });
  }

  // 金額フォーマット（Shopifyのフォーマットを使用）
  function formatMoney(cents) {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, theme.moneyFormat);
    }
    // フォールバック
    return "¥" + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // 円価格専用フォーマット（日本市場向け）
  function formatYenPrice(cents) {
    // 円価格として常に表示（ドルマーク回避）
    return "¥" + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // 商品情報を動的に取得
  function getProductInfoFromPage() {
    // 商品タイトルを取得
    const titleElement = document.querySelector(
      "h1[data-product-title], .product-title, h1"
    );
    const title = titleElement ? titleElement.textContent.trim() : "Product";

    // 商品価格を取得
    const priceElement = document.querySelector(
      ".price, [data-price], .product-price"
    );
    const price = priceElement ? priceElement.textContent.trim() : "";

    // 商品画像を取得
    const imageElement = document.querySelector(
      ".product-image img, .featured-image img, img"
    );
    const image = imageElement ? imageElement.src : "";

    return { title, price, image };
  }

  // イベントリスナーの設定
  function setupCartListeners() {

    // カート通知要素の存在確認
    const notification = document.getElementById("puremer-cart-notification");
    if (notification) {
    }

    // カート追加フォームのsubmitイベントをインターセプト
    document.addEventListener("submit", function (event) {
      if (event.target.matches('form[action*="/cart/add"]')) {
        event.preventDefault();

        const form = event.target;
        const variantIdInput = form.querySelector('input[name="id"]');
        const variantId = variantIdInput ? variantIdInput.value : null;

        if (variantId) {
          const productData = getProductInfoFromPage();

          // variant IDが有効かチェック
          if (variantId && variantId !== "undefined" && variantId !== "") {
            addToCart(
              variantId,
              productData,
              form.querySelector('button[type="submit"]')
            );
          }
        }
      }
    });

    // data-add-to-cart属性を持つ全要素にイベントを設定
    document.addEventListener("click", function (event) {
      const addToCartElement = event.target.closest("[data-add-to-cart]");

      if (addToCartElement) {
        event.preventDefault();

        const variantId = addToCartElement.dataset.addToCart;
        const productData = {
          title: addToCartElement.dataset.productTitle,
          price: addToCartElement.dataset.productPrice,
          image: addToCartElement.dataset.productImage,
        };


        if (variantId) {
          addToCart(variantId, productData, addToCartElement);
        }
      }
    });

    // カート通知の閉じるボタン
    const closeButton = document.querySelector(
      ".puremer-cart-notification__close"
    );
    if (closeButton) {
      closeButton.addEventListener("click", hideCartNotification);
    }

    // 初期カート数の取得
    fetchAndUpdateCart();
  }

  // DOMContentLoadedで初期化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupCartListeners);
  } else {
    setupCartListeners();
  }

  // グローバルに関数を公開（必要に応じて）
  window.cartFunctions = {
    addToCart: addToCart,
    showCartNotification: showCartNotification,
    hideCartNotification: hideCartNotification,
    updateCartBadge: updateCartBadge,
    fetchAndUpdateCart: fetchAndUpdateCart,
  };
})();
